import { useEffect, useState } from 'react'

export type NetworkStatus = 'online' | 'offline'

/**
 * Detect wether the user is offline or not, this only works client-side
 */
export const useIsOffline = (): boolean => {
  const [networkStatus, setNetworkStatus] = useState<NetworkStatus>(() => {
    /**
     * when we are run on the server we know the user had internet, so we known it is online
     */
    if (typeof window === 'undefined') {
      return 'online'
    }

    /**
     * We look on our navigator if user is online or not
     * please be aware this is not 100% correct
     */
    if ('onLine' in window.navigator) {
      if (window.navigator.onLine) {
        return 'online'
      }
      return 'offline'
    }

    /**
     * No detection is possible we act like we are online
     */
    return 'online'
  })

  const setOffline = () => setNetworkStatus('offline')
  const setOnline = () => setNetworkStatus('online')

  useEffect(() => {
    window.addEventListener('online', setOnline)
    window.addEventListener('offline', setOffline)

    return () => {
      window.removeEventListener('online', setOnline)
      window.removeEventListener('offline', setOffline)
    }
  }, [])

  return networkStatus === 'offline'
}
